var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-1",attrs:{"icon":""},on:{"click":_vm.openSupportPage}},'v-btn',Object.assign({}, attrs, _vm.$attrs),false),Object.assign({}, tooltip, _vm.$listeners)),[_c('v-icon',[_vm._v("mdi-lifebuoy")])],1)]}}])},[_c('span',[_vm._v(" Ask for help ")])])}
var staticRenderFns = []

export { render, staticRenderFns }